class SalesTimer extends HTMLElement {
  static targets = new Map();

  connectedCallback() {
    this.mode = this.dataset.mode || 'visitor';
    this.duration = Math.max(1, Number(this.dataset.duration) || 7200) * 1000;
    this.key = `sales-timer:${this.dataset.key}:${this.duration}`;
    this.target = this.getTarget();
    if (!Number.isFinite(this.target)) return;
    this.querySelector('[data-countdown]').hidden = false;
    this.update();
    if (this.mode !== 'fixed' || this.target > Date.now()) this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getTarget() {
    const now = Date.now();
    if (this.mode === 'fixed') return Date.parse(this.dataset.end || '');
    if (this.mode === 'midnight') {
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return midnight.getTime();
    }
    let target = SalesTimer.targets.get(this.key);
    try {
      target = Number(localStorage.getItem(this.key)) || target;
    } catch {}
    if (!Number.isFinite(target) || target <= now) target = now + this.duration;
    SalesTimer.targets.set(this.key, target);
    try { localStorage.setItem(this.key, String(target)); } catch {}
    return target;
  }

  update() {
    if (this.target <= Date.now() && this.mode !== 'fixed') this.target = this.getTarget();
    const seconds = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
    const values = { hours: Math.floor(seconds / 3600), minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
    for (const [unit, value] of Object.entries(values)) {
      this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2, '0');
    }
    if (seconds === 0) clearInterval(this.interval);
  }
}
if (!customElements.get('sales-timer')) customElements.define('sales-timer', SalesTimer);
